export default {
  getOpenBy: (state) => (route) => {
    if (!route) {
      return state.openBy
    }
    return state.openBy[route]
  },
  getUserDashboard(state) {
    return state.userDashboard?.dashboard || {}
  },
  getCount: (state) => (list) => {
    return state.count[list]
  },
  getAnonStatus: (state) => (id) => {
    if (!state.anonStatus[id]) return ""
    switch (state.anonStatus[id]) {
      case "error":
        return "Es ist ein Fehler aufgetreten. Stoppen Sie die Pseudonymisierung und versuchen Sie es später erneut."
      case "nofile":
        return ""
      default: {
        //Check für anonContainer
        if (!isNaN(state.anonStatus[id])) {
          return { progress: Math.round(Number(state.anonStatus[id]) * 100) }
        }
        const data = JSON.parse(state.anonStatus[id].replace(/'/g, '"'))
        return {
          progress: Math.round(Number(data.progress) * 100),
          docName: data.docName,
          processing: data.processing,
          status: data.status
        }
      }
    }
  },
  getAnalyzeProgress(state) {
    return state.analyzeProgress
  },
  getCorrectionProgress: (state) => (id) => {
    if (!state.correctionProgress[id]) return
    return Math.round(Number(state.correctionProgress[id]) * 100)
  }
}
